import { ref } from 'vue'

const DEV_MODE_KEY = 'devMode'

let devModeInstance: ReturnType<typeof createDevMode> | null = null

function createDevMode() {
  const isDevMode = ref(false)

  try {
    const stored = localStorage.getItem(DEV_MODE_KEY)
    isDevMode.value = stored ? JSON.parse(stored) : false
  } catch {
    isDevMode.value = false
  }

  const toggleDevMode = () => {
    isDevMode.value = !isDevMode.value
    localStorage.setItem(DEV_MODE_KEY, JSON.stringify(isDevMode.value))
  }

  return {
    isDevMode,
    toggleDevMode,
  }
}

export function useDevMode() {
  if (!devModeInstance) {
    devModeInstance = createDevMode()
  }
  return devModeInstance
}

